/**
 * Genera las credenciales de los estudiantes que no tienen.
 *
 * El API trabaja por lotes de unos segundos para no vencer el tiempo del
 * servidor; aquí se repite la llamada hasta que no queden pendientes. Si un
 * lote falla (red, tiempo agotado, servidor ocupado) se reintenta hasta tres
 * veces antes de darse por vencido: lo ya generado nunca se pierde.
 *
 * @param {(estado: {generadas: number, pendientes: number, total: number}) => void} alAvanzar
 * @returns {Promise<{generadas: number, pendientes: number, conflictos: Array}>}
 */
export async function generarCredencialesEstudiantes(alAvanzar = () => {}) {
    let generadas = 0;
    let pendientes = 0;
    let conflictos = [];
    let total = null;

    // Tope de seguridad: 1000 lotes de 200 cubren 200 mil cuentas.
    for (let vuelta = 0; vuelta < 1000; vuelta++) {
        const lote = await pedirLote();

        generadas += lote.generadas;
        pendientes = lote.pendientes;
        conflictos = lote.conflictos || [];

        if (total === null) total = lote.generadas + lote.pendientes;
        alAvanzar({generadas, pendientes, total});

        // Sin pendientes, o un lote que no avanzó: no tiene sentido insistir.
        if (pendientes === 0 || lote.generadas === 0) break;
    }

    return {generadas, pendientes, conflictos};
}

const REINTENTOS = 3;

async function pedirLote() {
    let ultimoError = null;

    for (let intento = 1; intento <= REINTENTOS; intento++) {
        try {
            const response = await window.axios.post('/personas/generar_credenciales_estudiantes', {}, {timeout: 120000});

            if (!response.data.success) {
                throw new Error(response.data.message || "No se pudo generar las credenciales.");
            }

            return response.data.data;
        } catch (error) {
            ultimoError = error;
            // Permisos o validación: no tiene sentido reintentar.
            const estado = error.response && error.response.status;
            if (estado === 401 || estado === 403 || estado === 422) break;
            await new Promise(r => setTimeout(r, 1500 * intento));
        }
    }

    const cuerpo = ultimoError && ultimoError.response && ultimoError.response.data;
    throw new Error((cuerpo && cuerpo.message) || ultimoError.message || "No se pudo generar las credenciales. Intente de nuevo: lo ya generado se conserva.");
}
